import React from 'react';
import { RouterHistory } from 'react-router-dom';
import queryString from 'query-string';
import { InitContext, InitCtx } from '../context/InitProvider';
import auth from '../Auth/Auth';
import { StringParam, useQueryParam } from 'use-query-params';
import { getIstaQueryParams } from '../Auth/utils';

type Props = {
  history: RouterHistory;
};

const Callback = ({ history }: Props) => {
  const { setAuthSuccess } = React.useContext<InitCtx>(InitContext);
  const [t] = useQueryParam('t', StringParam);

  React.useEffect(() => {
    const qs = queryString.parse(history.location.search);
    const redirectToSavedState = () => {
      const redirectState = auth.getAndClearRedirectState();
      if (redirectState) {
        history.replace(redirectState.pathname + redirectState.search);
      } else {
        history.replace('/');
      }
    };

    if (!auth.isAuthenticated()) {
      if (qs.error) {
        // Reachable when a partner connects with its own IdP before we identify the user; the ISTA
        // query param makes ui-auth show the enterprise login button.
        auth.login({
          signup: false,
          customQueryParams: getIstaQueryParams(t),
        });
      } else {
        auth.handleAuthentication(() => {
          setAuthSuccess();
          redirectToSavedState();
        });
      }
    } else {
      redirectToSavedState();
    }
  }, [history, setAuthSuccess]);

  return null;
};

export default Callback;
